import { useEffect } from 'react';

// De-load (ADR-013): cross-org / platform-admin surfaces live in the platform
// control-plane app, not the ERP. These routes no longer render here — they
// forward to platform-app, the single home for cross-org administration.
const PLATFORM_APP_URL =
  (import.meta.env.VITE_PLATFORM_APP_URL as string | undefined)?.replace(/\/+$/, '') ||
  'https://platform.zafroi.com';

export function PlatformRedirect({ to }: { to: string }) {
  useEffect(() => {
    const path = to.startsWith('/') ? to : `/${to}`;
    window.location.replace(`${PLATFORM_APP_URL}${path}`);
  }, [to]);

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-2 text-center">
      <p className="text-sm font-medium text-foreground">
        Opening the ZAFROI platform console…
      </p>
      <p className="text-xs text-muted-foreground">
        This area moved to the platform app. Redirecting you now.
      </p>
    </div>
  );
}
